<template>
  <div class="index-container">
    <BackTop></BackTop>
    <div class="login" v-show="loginFlag">
      <div class="login-bg" @click="loginFlag = false"></div>
      <div class="login-main">
        <Form label-position="top">
          <div class="form-wrap" v-show="loginShow">
            <div class="title">登录</div>
            <FormItem class="form-item">
              <Input class="login-input" type="text" size="large" v-model="formLogin.username" placeholder="请输入登录用户名/手机号" @on-enter="login" />
            </FormItem>
            <FormItem class="form-item">
              <Input class="login-input" type="password" size="large" v-model="formLogin.password" placeholder="请输入登录密码" @on-enter="login" />
            </FormItem>
            <FormItem class="form-item">
              <div style="display: flex; justify-content: space-between; margin-bottom: 20px; line-height: 1">
                <a href="javascript:;" @click="goForget">忘记密码</a>
                <!-- <a href="javascript:;" @click="goReg">没有账号？立即注册</a> -->
              </div>
            </FormItem>
            <FormItem class="form-item" style="margin-bottom: 0">
              <Button class="login-btn" size="large" long @click="login" :loading="loginLoading" :disabled="!formLogin.username || !formLogin.password">立即登录</Button>
            </FormItem>
          </div>
          <div class="form-wrap" v-show="forgetShow">
            <div class="title">忘记密码</div>
            <FormItem class="form-item">
              <div class="text-center" style="font-size:16px;">请联系管理员哦</div>
            </FormItem>
            <!-- <FormItem class="form-item">
              <Input class="login-input" type="text" size="large" v-model="formForget.mobile" maxlength="11" placeholder="请输入手机号" @on-enter="login" />
            </FormItem>
            <FormItem class="form-item">
              <div style="display: flex; justify-content: space-between;">
                <Input class="login-input code" type="text" size="large" v-model="formForget.code" maxlength="6"
                       placeholder="请输入验证码" style="width: calc(100% - 150px)" />
                <Button class="login-btn msg-code-btn" @click="getCode(2)" :disabled="getCodeFlag || !formForget.mobile">{{getCodeFlag ? countdownNum + '秒后重发' : '获取验证码' }}</Button>
              </div>
            </FormItem> -->
            <!-- <FormItem class="form-item" style="margin-bottom: 0">
              <Button class="login-btn" size="large" long @click="goForget2" :disabled="!formForget.mobile || !formForget.code">下一步</Button>
            </FormItem> -->
            <FormItem class="form-item" style="margin-bottom: 0">
              <Button class="login-btn" long @click="goForget2">确认</Button>
            </FormItem>
          </div>
          <div class="form-wrap" v-show="forgetShow2">
            <div class="title">忘记密码</div>
            <FormItem class="form-item">
              <div class="text-center" style="color: rgb(204, 204, 204);">请您妥善保管密码防止再次丢失</div>
            </FormItem>
            <FormItem class="form-item">
              <Input class="login-input" type="password" size="large" v-model="formForget.password" placeholder="请输入登录密码" />
            </FormItem>
            <FormItem class="form-item">
              <Input class="login-input" type="password" size="large" v-model="formForget.password2" placeholder="再次输入登录密码" />
            </FormItem>
            <FormItem class="form-item" style="margin-bottom: 0">
              <Button class="login-btn" size="large" long @click="postForget" :disabled="!formForget.password || !formForget.password2">修改密码</Button>
            </FormItem>
            <!--<FormItem class="form-item">-->
            <!--<div class="text-center">-->
            <!--<a href="javascript:;" @click="goLogin">去登录></a>-->
            <!--</div>-->
            <!--</FormItem>-->
          </div>
          <div class="form-wrap" v-show="regShow">
            <div class="title">注册账号</div>
            <!--<div class="spacingTwice">-->
            <!--目前投屏广告联盟采用邀请注册制<br>-->
            <!--请发送申请邮件至<a href="mailto:service@hiliad.com">service@hiliad.com</a><br>-->
            <!--需包含登录用户名、手机号、公司邮箱、公司全称与简称、公司营业执照复印件<br>-->
            <!--我们审核通过后即为您开通账号，您获得账号后可自行修改密码<br>-->
            <!--</div>-->
            <FormItem class="form-item">
              <Input class="login-input" type="text" size="large" maxlength="20" v-model="formReg.username" placeholder="请输入登录用户名" />
            </FormItem>
            <FormItem class="form-item">
              <Input class="login-input" type="password" size="large" v-model="formReg.password" placeholder="请输入登录密码" />
            </FormItem>
            <FormItem class="form-item">
              <Input class="login-input" type="password" size="large" v-model="formReg.password2" placeholder="再次输入登录密码" />
            </FormItem>
            <FormItem class="form-item">
              <div style="display: flex; justify-content: space-between;">
                <Input class="login-input" type="text" size="large" value="+86" style="width: 65px;" readonly />
                <Input class="login-input" type="text" size="large" maxlength="11" v-model="formReg.mobile" placeholder="请输入手机号" style="width: calc(100% - 75px)" />
              </div>
            </FormItem>
            <FormItem class="form-item">
              <div style="display: flex; justify-content: space-between;">
                <Input class="login-input code" type="text" size="large" v-model="formReg.code" maxlength="6"
                       placeholder="请输入验证码" style="width: calc(100% - 150px)" />
                <Button class="login-btn msg-code-btn" size="large" @click="getCode(1)" :disabled="getCodeFlag || !formReg.mobile">{{getCodeFlag ? countdownNum + '秒后重发' : '获取验证码' }}</Button>
              </div>
            </FormItem>
            <FormItem class="form-item" style="margin-bottom: 0">
              <Button class="login-btn" size="large" long @click="postReg" :disabled="!formReg.username || !formReg.password || !formReg.mobile || !formReg.password2 || !formReg.code || !agree">同意服务条款并注册</Button>
            </FormItem>
            <FormItem class="form-item" style="margin-bottom: 0">
              <Checkbox v-model="agree"></Checkbox> <a target="_blank" href="/static/legal.html">《快应用服务协议及用户隐私声明》</a>
            </FormItem>
            <!--<FormItem class="form-item">-->
            <!--<div class="text-center">-->
            <!--<a href="javascript:;" @click="goLogin">已有账号 去登录></a>-->
            <!--</div>-->
            <!--</FormItem>-->
          </div>
        </Form>
      </div>
    </div>
    <div v-show="!isShowUploadList" class="index-header"></div>
    <div v-show="isShowUploadList" class="index-upload-header">
    </div>
    <div class="index-nav index-w-1200">
      <div class="index-logo">
        <img src="../assets/images/logo.png">
      </div>
      <div class="index-menu">
        <div class="mobile-menu" :class="{open: menuShow}">
          <router-link to="/developer/esApp" v-if="developer">控制台</router-link>
          <a @click="home">首页</a>
          <a @click="upload">下载中心</a>
          <!--<router-link to="/news">资讯</router-link>-->
          <a target="_blank" href="http://developer.extscreen.com/">快应用文档中心</a>
          <a v-if="developer && !menuShow" href="javascript:;">你好，{{username}}</a>
        </div>
        <a v-if="!developer" class="btn-link" href="javascript:;" @click="goLogin">登录</a>
        <a v-if="!developer" class="btn-link" href="javascript:;" @click="goReg">快速注册</a>
        <a v-if="developer" class="btn-link" href="javascript:;" @click="logout">退出登录</a>
        <div class="mobile-menu-btn" :class="{open: menuShow}" @click="menuShow = !menuShow">
          <div class="menu-icon"></div>
          <div class="close-icon"></div>
        </div>
      </div>
    </div>
    <div class="banner" v-show="!isShowUploadList" @click="menuShow = false">
      <div class="banner-txt">
        <p>HLTECH·Expansion Screen</p>
        <strong class="title">高光·快应用</strong>
        <strong class="spacingTwice">TV&手机联动快应用引擎</strong>
        <span>JS快速开发、快速上线、零碎片化，帮您打造快速登录千万家庭大屏通道</span>
      </div>
      <div class="banner-pic">
        <img src="../assets/images/banner-pt.png">
      </div>
    </div>
    <a href="https://extcdn.hsrc.tv/extend_screen/files/es_app/quick_app_general_2.5.1048_20230925105746_release.apk" class="m-upload-pop"></a>
    <div class="upload-mr-t" v-show="isShowUploadList">
      <div v-for="(item, index) in classify" class="upload-p-b" :key="index" :style="index%2 != 1?'background:#fff;':'background:#fafafa;'">
        <div class="ind-1 ind-wrap ind-wrap-upload">
          <div class="title-wrap text-center">
            <div class="base-title-m">
              <span>{{item.categoryName}}</span>
            </div>
          </div>
        </div>
        <div class="upload-card-box">
          <div class="upload-card" v-for="(sItem, sIndex) in item.extAppAccountResultList" :key="sIndex">
            <div class="upload-img-card">
              <img class="upload-img" :src="sItem.app.recommendPic.replace('http://qcloudimg.a311.ottcn.com','https://extcdn.hsrc.tv')" />
              <a href="https://extcdn.hsrc.tv/extend_screen/files/es_app/quick_app_general_2.5.1048_20230925105746_release.apk" class="upload-pop">
                <img class="upload-pop-img" src="../assets/images/download-icon.png"/>
                <div class="upload-pop-text">下载演示demo</div>
              </a>
            </div>
            <div class="upload-content-card">
              {{sItem.app.appName}}
              <!-- <div class="upload-content">{{sItem.app.appName}}</div> -->
              <!-- <div class="upload-content-tip">{{sItem.app.remark}}</div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="!isShowUploadList">
      <div class="ind-1 ind-wrap">
        <div class="title-wrap text-center">
          <div class="base-title">
            <span>快应用 — 大小屏联动的最优解</span>
          </div>
        </div>
        <div class="ind-con index-w-1200">
          <div class="ind-1-item">
            <div class="title">DLNA投屏</div>
            <p>只能为单个流媒体视频，不支持任何界面设计、不支持任何操作交互，不适合时长较短、数量多的视频</p>
          </div>
          <div class="ind-1-item focus">
            <div class="title">快应用</div>
            <p>秒速启动基于快应用引擎的快应用</p>
            <p>性能可达原生APP级</p>
            <p>运行在电视端，支持基于电视的全部交互能力</p>
            <p>无隐私暴露风险</p>
          </div>
          <div class="ind-1-item">
            <div class="title">屏幕镜像</div>
            <p>交互操作依然在手机上，手机一直被占用；个人隐私有严重暴露风险</p>
          </div>
        </div>
      </div>
      <div class="ind-2 ind-wrap" id="ind-2">
        <div class="title-wrap text-center">
          <div class="base-title">
            <span>快应用交互流程 · 投应用</span>
          </div>
        </div>
        <div class="ind-con index-w-1200">
          <div class="mobile" data-aos="fade-right" data-aos-anchor="#ind-2" data-aos-delay="100">
            <div class="mobile-mark" data-aos="fade" data-aos-anchor="#ind-2" data-aos-delay="1600">
              <img src="../assets/images/iphone-ad.png" class="mobile-ad">
            </div>
          </div>
          <div class="arrow">
            <img src="../assets/images/arrow-top.png" data-aos="fade-right" data-aos-anchor="#ind-2" data-aos-delay="600">
            <img src="../assets/images/arrow-bottom.png" data-aos="fade-left" data-aos-anchor="#ind-2" data-aos-delay="1600">
          </div>
          <div class="tv" data-aos="fade-left" data-aos-anchor="#ind-2" data-aos-delay="100">
            <img data-aos="fade" data-aos-anchor="#ind-2" data-aos-delay="1100" src="../assets/images/tv-jpg.png">
          </div>
        </div>
      </div>

      <div class="ind-3 ind-wrap">
        <div class="ind-3-bg">
          <div class="ind-3-pic"></div>
          <div class="ind-3-txt">
            <p>JS代码调用组件<span class="color-blue">快速实现功能</span>，帮您将精力<strong>聚焦业务逻辑</strong></p>
            <p>组件开发、JS转原生、系统适配，这些<strong class="color-blue">麻烦事，交给我们处理</strong></p>
          </div>
        </div>
      </div>

      <div class="ind-4 ind-wrap">
        <div class="ind-con index-w-1200">
          <div class="title">大屏看内容，是切实的需求</div>
          <div class="content">
            <span>轻松状态</span>
            <p>在更轻松的状态下观看内容：</p>
            <p>用户在家做一些轻家务，或手机聊天之类不需绝对集中注意力的情况下，会更愿意通过大屏播放内容</p>
          </div>
          <div class="content">
            <span>保护视力</span>
            <p>手机或Pad都是手持设备，对视力的伤害都远超过电视。</p>
            <p>电视的观看角度更友好</p>
            <p>坐姿更舒适也起到保护颈椎作用</p>
          </div>
        </div>
      </div>

      <div class="ind-5 ind-wrap">
        <div class="title-wrap text-center">
          <div class="base-title">
            <span>快应用全系统通用</span>
          </div>
        </div>
        <div class="sub-title">快速集成快速实现效果</div>
        <div class="ind-con index-w-1200">
          <div class="ind-5-item">
            <img src="../assets/images/ios.png">
            <p>IOS系统</p>
            <span>提供手机端SDK或标准协议代码</span>
          </div>
          <div class="ind-5-item">
            <img src="../assets/images/android.png">
            <p>Android系统</p>
            <span>提供手机端SDK或标准协议代码</span>
          </div>
          <div class="ind-5-item">
            <img src="../assets/images/wechat.png">
            <p>微信小程序&标准H5</p>
            <span>提供标准调用方法 </span><span class="color-blue">局域网mDNS方式</span>
          </div>
        </div>
      </div>

      <div class="ind-6 ind-wrap">
        <div class="ind-6-title text-center">
          <span>为什么要选择快应用？</span>
          <p>我们具有<strong class="color-blue">三大优势</strong></p>
        </div>
        <div class="ind-con index-w-1200 advantage">
          <div class="advantage-item" style="background-color: #4f1ac6">
            <p class="item-title">创新<span>首发</span>优势</p>
            <p>引擎创造的业态创新性吸引了众多合作伙伴，牌照方、终端厂商、运营商和数字营销平台的加入让我们可以提供全流程服务</p>
            <img src="../assets/images/shoufa_icon.png" class="item-icon">
          </div>
          <div class="advantage-item" style="background-color: #1630e9">
            <p class="item-title">渠道<span>覆盖</span>优势</p>
            <p>依托合OTT合作方一亿+终端和运营商合作，带来了几千万的终端覆盖，能为合作方提供快速落地OTT和机顶盒的通道</p>
            <img src="../assets/images/fugai_icon.png" class="item-icon">
          </div>
          <div class="advantage-item" style="background-color: #01aea1">
            <p class="item-title">研发<span>运营</span>优势</p>
            <p>汗粮产品研发团队拥有以深耕多年的TV端手机端联动产品设计、交互设计经验，和平台型产品经验，能帮您快速完成业务移植和开发</p>
            <img src="../assets/images/yunying_icon.png" class="item-icon">
          </div>
        </div>
        <div class="ind-con index-w-1200 fugai">
          <div class="title-item">
            <p class="sub-title">快应用应用</p>
            <p class="title">助您快速覆盖大屏</p>
            <p>快应用底层技术保证用户快速流畅的体验</p>
            <p>提供完善的开发工具及平台，APP集成快应用SDK 和 TV快应用开发周期缩短至一周内</p>
            <p><br></p>
            <p class="color-blue">适合没有TV端或TV端用户量较少的开发者</p>
          </div>
          <div class="fugai-item">
            <img src="../assets/images/bzmb.png" class="item-icon">
            <p class="title">标准模版</p>
            <p>汗粮提供有大屏需求的六大行业标准模板，替换VI元素即可快速实现</p>
          </div>
          <div class="fugai-item">
            <img src="../assets/images/dzkf.png" class="item-icon">
            <p class="title">定制开发</p>
            <p>①开发者可自行设计开发大屏界面交互，汗粮科技提供完整的规范说明及技术支持</p>
            <p>②汗粮科技提供快应用代开发服务</p>
          </div>
        </div>
      </div>

      <div class="ind-7 ind-wrap">
        <div class="ind-con index-w-1200">
          <div class="ind-7-item">
            <img src="../assets/images/tjw.png">
            <p>推荐位</p>
            <span>基于内容的推荐，以TV桌面任意推荐位吸引用户，根据具体情况运营</span>
          </div>
          <div class="ind-7-item item-focus">
            <img src="../assets/images/kyy.png">
            <p>我的快应用</p>
            <span>电视端保留用户使用过的快应用，提供优质入口位</span>
          </div>
          <div class="ind-7-item">
            <img src="../assets/images/kyyzq.png">
            <p>快应用专区</p>
            <span>在合作方桌面、应用商店中留有专区，专区内容均无需安装，提供优质的用户体验</span>
          </div>
        </div>
      </div>

      <div class="ind-8 ind-wrap">
        <div class="ind-con index-w-1200">
          <img src="../assets/images/hxcj.png">
          <div class="ind-8-txt">
            <p class="title color-blue">核心场景</p>
            <p>绝大多数有大屏需求APP的播放界面，占 90%以上的用户时长</p>
            <p><br></p>
            <p class="title">非核心场景</p>
            <p>非核心的用户服务场景，更适合手机交互，如个人信息、付费、分享等</p>
            <p><br></p>
            <p>核心场景 播放界面由快应用应用实现</p>
            <p>非核心场景 由手机端APP满足用户需求</p>
          </div>
        </div>
      </div>

    </div>
    <footer class="footer">
      <p><a target="_blank" href="/static/service.html">用户协议</a> | <a target="_blank" href="/static/legalC.html">隐私政策</a>  | <a target="_blank" href="https://www.yecao.net">野草助手</a></p>
      <p>Copyright © 2019-2021 hiliad.com All rights reserved. 北京汗粮科技有限公司 版权所有 <a href="http://beian.miit.gov.cn">京ICP备19043080号-6</a></p>
    </footer>
  </div>
</template>
<script>
import AOS from 'aos'
import https from '../https'
export default {
  name: 'web',
  data () {
    return {
      isShowUploadList: false,
      classify: [],
      developer: false,
      loginFlag: false,
      loginShow: true,
      regShow: false,
      forgetShow: false,
      forgetShow2: false,
      getCodeFlag: false,
      agree: true,
      userInfoFlag: false,
      editPwdFlag: false,
      menuShow: false,
      countdownNum: 60,
      username: '',
      msgText: '获取验证码',
      loginLoading: false,
      formLogin: {
        username: '',
        password: ''
      },
      formReg: {
        username: '',
        password: '',
        password2: '',
        mobile: '',
        code: ''
      },
      formForget: {
        password: '',
        password2: '',
        mobile: '',
        code: ''
      },
      pwdValidate: {
        password: '',
        password2: ''
      },
      ruleValidatePwd: {
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { type: 'string', min: 6, message: '密码长度最少6位', trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '再次输入登录密码', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    AOS.init()
    this.getClassify()
    if (https.token) {
      this.developer = true
      this.username = window.localStorage.getItem('userName')
      let goEsapp = window.localStorage.getItem('go_esapp')
      if (goEsapp === true || goEsapp === 'true') {
        this.$router.push('/developer/esApp')
        window.localStorage.setItem('go_esapp', false)
      }
    }
    let url = this.getUrlParams(window.location.href)
    if (Object.keys(url).length > 0) {
      this.isShowUploadList = true
    }
  },
  methods: {
    getUrlParams (url) {
      try {
        let urlStr = url.split('?')[1]
        let obj = {}
        let paramsArr = urlStr.split('&')
        for (let i = 0, len = paramsArr.length; i < len; i++) {
          let arr = paramsArr[i].split('=')
          obj[arr[0]] = arr[1]
        }
        return obj
      } catch (error) {
        return {}
      }
    },
    getClassify () {
      https.requestcms({
        method: 'post',
        url: 'https://extscreen.huan.tv/extend_api//api/v2/zero/arrange/layoutMyApp',
        data: {
          developer: {
            apikey: '2V29G3SD',
            secretkey: '5faa1c397ed64d09a17ab89b6b19d373'
          },
          data: '最新上线',
          data1: 'webPageFlag'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(res => {
        https.requestcms({
          method: 'post',
          url: 'https://extscreen.huan.tv/extend_api/api/v2/zero/arrange/layoutCategoryAndApp',
          data: {
            developer: {
              apikey: '2V29G3SD',
              secretkey: '5faa1c397ed64d09a17ab89b6b19d373'
            },
            data: '',
            data1: 'webPageFlag'
          },
          headers: {
            'Content-Type': 'application/json'
          }
        }).then(res1 => {
          // http://qcloudimg.a311.ottcn.com/data_center/files/2023/04/19/dbbb17ec-6729-411c-bdda-0042b6384800.jpg
          res1.data.unshift({
            categoryName: '最新上线',
            extAppAccountResultList: res.data
          })
          this.classify = res1.data
        }).catch(error => {
          this.$Message.error(error)
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    home () {
      this.isShowUploadList = false
    },
    upload () {
      this.isShowUploadList = true
    },
    toDeveloper () {
      this.$router.push('/developer/esApp')
    },
    goReg () {
      this.loginFlag = true
      this.regShow = true
      this.loginShow = false
      this.forgetShow = false
    },
    goForget () {
      this.$Message.info('请联系管理员')
      // this.forgetShow = true
      // this.loginShow = false
    },
    goForget2 () {
      this.forgetShow = false
      this.loginShow = true
      // if (this.validMobile(this.formForget.mobile)) {
      //   https.request({
      //     method: 'post',
      //     url: '/check',
      //     data: {
      //       mobile: this.formForget.mobile,
      //       code: this.formForget.code,
      //       type: 'reset'
      //     }
      //   }).then(res => {
      //     this.forgetShow2 = true
      //     this.forgetShow = false
      //     this.token = res.data.token
      //   }).catch(error => {
      //     this.$Message.error(error)
      //   })
      // }
    },
    goLogin () {
      this.loginFlag = true
      this.regShow = false
      this.forgetShow = false
      this.forgetShow2 = false
      this.loginShow = true
    },
    clearTimer () {
      clearInterval(this.codeTimer)
      this.getCodeFlag = false
      this.countdownNum = 60
    },
    countdown () {
      let seconds = this.countdownNum - 1
      if (seconds < 10) seconds = '0' + seconds
      this.countdownNum = seconds
      if (parseInt(this.countdownNum) === 0) {
        this.clearTimer()
      }
    },
    validMobile (value) {
      let re = /^1\d{10}$/
      if (re.test(value)) {
        return true
      } else {
        this.$Message.error('请输入有效的手机号码')
        return false
      }
    },
    validPwd (value, value2) {
      if (value === value2) {
        return true
      } else {
        this.$Message.error('两次密码不一致')
        return false
      }
    },
    getCode (type) {
      let mobile = (type === 1 ? this.formReg.mobile : this.formForget.mobile)
      if (this.validMobile(mobile)) {
        let params = {
          mobile,
          type
        }
        if (type === 1) params.username = this.formReg.username
        this.getCodeFlag = true
        https.request({
          method: 'post',
          url: '/sms',
          data: params
        }).then(res => {
          this.$Message.success('发送成功')
          this.codeTimer = setInterval(this.countdown, 1000)
        }).catch(error => {
          this.$Message.error(error)
          this.getCodeFlag = false
        })
      }
    },
    login () {
      if (!this.formLogin.password || !this.formLogin.username) {
        this.$Message.error('请输入用户名和密码')
        return
      }
      this.loginLoading = true
      https.request({
        method: 'post',
        url: 'login',
        headers: {
          'Content-Type': 'application/json'
        },
        data: this.formLogin
      }).then(res => {
        this.loginLoading = false
        if (res.code === 500) {
          this.$Message.error(res.msg)
          return
        }
        window.localStorage.setItem('token', res.data)
        // window.localStorage.setItem('token', res.data.token)
        // window.localStorage.setItem('userId', res.data.id)
        // window.localStorage.setItem('role_id', res.data.role_id)
        window.localStorage.setItem('userName', this.formLogin.username)
        window.localStorage.setItem('go_esapp', true)
        this.username = this.formLogin.username
        this.$Message.success({
          content: '登录成功',
          onClose: () => {
            this.developer = true
            this.loginFlag = false
            location.reload()
          }
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    login2 () {
      location.href = 'https://sso.hpplay.cn:8280/sso-cas-https/page/login?redirectURI=https://cloud.hpplay.cn:9889/dev/login'
    },
    postReg () {
      if (this.validMobile(this.formReg.mobile) && this.validPwd(this.formReg.password, this.formReg.password2)) {
        if (this.formReg.password.length < 6) {
          this.$Message.error('密码长度最短6位')
          return
        }
        if (this.formReg.username.length < 2) {
          this.$Message.error('用户名长度2-20个字')
          return
        }
        https.request({
          method: 'post',
          url: '/register',
          data: {
            username: this.formReg.username,
            password: this.formReg.password,
            mobile: this.formReg.mobile,
            code: this.formReg.code
          }
        }).then(res => {
          this.$Message.success({
            content: '注册成功, 请登录',
            onClose: () => {
              this.regShow = false
              this.loginShow = true
            }
          })
        }).catch(error => {
          this.$Message.error(error)
        })
      }
    },
    postForget () {
      if (this.validPwd(this.formForget.password, this.formForget.password2)) {
        if (this.formForget.password.length < 6) {
          this.$Message.error('密码长度最短6位')
          return
        }
        https.request({
          method: 'post',
          url: '/reset',
          data: {
            password: this.formForget.password
          },
          headers: {
            token: this.token
          }
        }).then(res => {
          this.$Message.success({
            content: '修改成功, 请登录',
            onClose: () => {
              this.forgetShow2 = false
              this.loginShow = true
            }
          })
        }).catch(error => {
          this.$Message.error(error)
        })
      }
    },
    editPwd () {
      this.editPwdFlag = true
      this.userInfoFlag = false
    },
    postPwd () {
      this.$refs['pwdValidate'].validate((valid) => {
        if (valid) {
          setTimeout(() => {
            this.changeLoading()
            if (this.validPwd(this.pwdValidate.password, this.pwdValidate.password2)) {
              this.editPwdFlag = false
              https.request({
                method: 'post',
                url: '/reset',
                data: {
                  password: this.pwdValidate.password
                }
              }).then(res => {
                this.$Message.success('修改成功')
              }).catch(error => {
                this.$Message.error(error)
              })
            }
          }, 1000)
        } else {
          this.changeLoading()
        }
      })
    },
    logout () {
      https.request({
        method: 'get',
        url: '/logout'
      }).then(res => {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('userId')
        window.localStorage.removeItem('userName')
        window.localStorage.removeItem('role_id')
        this.userInfoFlag = false
        this.$Message.success({
          content: '退出登录成功',
          onClose: () => {
            this.developer = false
          }
        })
      }).catch(error => {
        this.$Message.error(error)
      })
    },
    changeLoading () {
      this.loading = false
      this.$nextTick(() => {
        this.loading = true
      })
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/val";
  @import "../assets/global";
  @import "../assets/index.css";
  .login {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1001;
    .login-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(5, 6, 26, 0.5);
    }
    .login-main {
      position: absolute;
      z-index: 2;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      .title {
        font-size: 24px;
        color: #05061a;
        margin-bottom: 10px;
      }
      .form-wrap {
        width: 478px;
        background: #fff;
        margin: 0 auto;
        padding: 30px;
        border-radius: 4px;
      }
      .form-item {
        margin-bottom: 15px;
      }
      .login-input .ivu-input {
        border-radius: 4px;
        border: solid 1px rgba(5, 6, 26, 0.26);
        height: 52px;
        line-height: 50px;
        padding: 0 15px;
        font-size: 16px;
        &:focus {
          border-color: #1630e9;
          box-shadow: none;
        }
      }
      .login-btn {
        background-color: #1630e9;
        border-color: #1630e9;
        height: 52px;
        line-height: 50px;
        color: #fff;
        border-radius: 4px;
      }
      .login-btn[disabled] {
        color: #fff;
        background-color: rgba(22, 48, 233, 0.5);
        border-color: rgba(22, 48, 233, 0.5);
      }
      a {
        color: #1630e9;
        font-size: 12px;
      }
      .ivu-checkbox-inner {
        border-color: #1630e9;
      }
      .ivu-checkbox-checked .ivu-checkbox-inner {
        background: none;
      }
      .ivu-checkbox-checked .ivu-checkbox-inner:after {
        border: 2px solid #1630e9;
        border-top: 0;
        border-left: 0;
      }
      .msg-code-btn {
        width: 140px;
        display: inline-block;
        text-align: center;
        cursor: pointer;
        background-color: rgba(5, 6, 26, 0.86);
        border-color: rgba(5, 6, 26, 0.86);
        &[disabled] {
          color: #fff;
          background-color: rgba(5, 6, 26, 0.46);
          border-color: rgba(5, 6, 26, 0.46);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/web.vue